import React from 'react';
import './Checkbox.css';

const Checkbox = ({ checked, onChange, label }) => {
  return (
    <div className="checkbox-container">
      <input
        type="checkbox"
        className="checkbox-input"
        checked={checked}
        onChange={onChange}
      />
      <label className="checkbox-label" onClick={onChange}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
